import { tokens } from "@blurb/codex-react";
import { ComponentProps } from "react";
import { DefaultLegendContent } from "recharts";
import { Body } from "../Typography";
import { createStyles } from "@mantine/core";
import { LegendPayload } from "recharts/types/component/DefaultLegendContent";

const useStyles = createStyles(() => ({
  chartLegend: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    gap: tokens.spacing[2],
  },
  chartLegendItem: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacing[1],
  },
  chartLegendItemIcon: {
    width: 14,
    height: 14,
    borderRadius: tokens.radius.sm,
  },
}));

export const ChartLegendItem: React.FC<{ item: LegendPayload; size?: "sm" | "xs" }> = ({ item, size = "xs" }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.chartLegendItem}>
      <div style={{ backgroundColor: item.color }} className={classes.chartLegendItemIcon} />
      <Body size={size}>{item.value}</Body>
    </div>
  );
};

export const ChartLegend: React.FC<ComponentProps<typeof DefaultLegendContent>> = ({ payload }) => {
  const { classes } = useStyles();

  if (!payload) return null;

  return (
    <div className={classes.chartLegend}>
      {payload.map((p, idx) => (
        <ChartLegendItem key={idx} item={p} size="sm" />
      ))}
    </div>
  );
};
